export function isKanbanColumnFetchAborted(error: unknown, signal?: AbortSignal): boolean {
  if (signal?.aborted) return true;
  if (error == null || typeof error !== "object") return false;
  if (error instanceof DOMException && error.name === "AbortError") return true;
  const maybe = error as { name?: string; code?: string; message?: string };
  return (
    maybe.name === "AbortError" ||
    maybe.name === "CanceledError" ||
    maybe.code === "ERR_CANCELED" ||
    maybe.message === "canceled"
  );
}
